import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ThemeConsumer } from 'contexts/theme-context'
import Link from 'atoms/Link'
import Submenu from 'molecules/Submenu'

const Wrapper = styled.div`
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  transition:
    opacity 0.2s ease-in-out 0s,
    transform 0.2s ease-in-out 0s;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  overflow-x: auto;
`

const UL = styled.ul`
  padding: 0;
  margin: 0;
  max-width: 100%;
`

const LI = styled.li`
  display: inline;
  padding: 0;
`

const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  line-height: 16px;
  color: rgb(123, 139, 142);
  font-weight: normal;
  border-bottom: 3px solid rgb(255, 255, 255);
  flex: 1 1 auto;
  padding: 12px 16px;

  :hover,
  :active,
  :focus {
    border-color: ${(p) => p.hoverColor};
    color: inherit;
  }

  :visited {
    color: inherit;
  }
`

class SubNav extends React.Component {
  componentDidMount() {
    const { config } = this.props
    if (config.subNavItems) {
      document.querySelector('#universal-header').classList.add('show-subnav-bar')
    }
  }
  render() {
    const { config } = this.props
    if (!config.subNavItems) {
      return null
    }
    return (
      <ThemeConsumer>
        {(theme) => {
          return (
            <Wrapper>
              <UL>
                {config.subNavItems.map((item) => (
                  <LI key={`subnav-item-${item.text}`}>
                    {item.subItems ? (
                      <Submenu items={item.subItems} onSiteLink={true}>
                        <StyledLink hoverColor={theme.color} href={item.url}>
                          {item.text}
                        </StyledLink>
                      </Submenu>
                    ) : (
                      <StyledLink hoverColor={theme.color} href={item.url}>
                        {item.text}
                      </StyledLink>
                    )}
                  </LI>
                ))}
              </UL>
            </Wrapper>
          )
        }}
      </ThemeConsumer>
    )
  }

  static propTypes = {
    config: PropTypes.object.isRequired,
  }
}

export default SubNav



// WEBPACK FOOTER //
// ./src/molecules/SubNav/SubNav.js